import { AzureBlobFSWriteSettings } from 'app/model/pipeline/copysink/store-write-settings/azure-blob-fs-store-write-settings';
import { Metamodel, OneLakeFileLinkedService } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.oneLakeFile.storeWrite,
    display: [],
    tags: { linkedServiceModel: Metamodel.modelFor(OneLakeFileLinkedService) }
})
export class OneLakeFilesWriteSettings extends AzureBlobFSWriteSettings {}
